import mahatreyaVoice1 from "../assets/audio/MahatriaVoice1.wav";
import mahatreyaVoice2 from "../assets/audio/MahatriaVoice2.wav";
import mahatreyaVoice3 from "../assets/audio/MahatriaVoice3.wav";

export const mahatreyaAudioMessages = [
  mahatreyaVoice1,
  mahatreyaVoice2,
  mahatreyaVoice3,
];